<template>
    <v-avatar :size="size">
        <v-img v-if="hasImage" :src="image" :alt="name" cover>
            <template #error>
                <div class="ua-fallback" :style="fallbackStyle">{{ initials }}</div>
            </template>
        </v-img>
        <div v-else class="ua-fallback" :style="fallbackStyle">{{ initials }}</div>
    </v-avatar>
</template>

<script setup>
import {computed} from "vue";
import {avatarColor, initials as initialsOf} from "@/composables/appDesign";

// Shows the person's photo when one is set, otherwise their first + last
// initials in bold white on a per-name color, so a missing picture still
// reads as a real avatar. Same look as the mobile app. The background is set
// with an inline style (not the v-avatar color prop) so it always paints -
// otherwise the initials render white-on-nothing and look blank.
const props = defineProps({
    image: {type: String, default: ""},
    name: {type: String, default: ""},
    size: {type: [Number, String], default: 40},
});

const hasImage = computed(() => typeof props.image === "string" && props.image.length > 0);

const initials = computed(() => initialsOf(props.name));

const bgColor = computed(() => avatarColor(props.name));

const fallbackStyle = computed(() => {
    const n = Number(props.size);
    const px = Number.isFinite(n) ? Math.round(n * 0.4) : 16;
    return {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: bgColor.value,
        color: "#ffffff",
        fontWeight: 700,
        fontSize: `${px}px`,
        lineHeight: 1,
    };
});
</script>
